// file generated by the Paraglide-Next init command
import { Navigation, Middleware } from '@inlang/paraglide-next';
import type { AvailableLanguageTag } from '@/paraglide/runtime';
import MyDomainStrategy from 'shared/lib/utils/my-domain-strat';

export const dynamic = 'force-dynamic';
// Create a function to get the ruUrl dynamically
// export function getRuUrl() {
//   const region = process.env.NEXT_PUBLIC_AMVERA_REGION;
//   const isDev = process.env.NODE_ENV === 'development';

//   console.log('NEXT_PUBLIC_AMVERA_REGION:', region);

//   if (region === 'msk1') {
//     const url = isDev
//       ? 'http://localhost'
//       : 'https://frontend.msk1.amvera.tech';
//     console.log('ruUrl:', url, '(msk1 region)');
//     return url as `${'http://' | 'https://'}${string}`;
//   }

//   console.log('ruUrl: https://cloud.amvera.ru (default region)');
//   return 'https://cloud.amvera.ru' as `https://${string}`;
// }

// Create a mutable domains object that can be updated at runtime
const domains: Record<
  AvailableLanguageTag,
  Array<`${'http://' | 'https://'}${string}`>
> = {
  ru: [
    'https://cloud.amvera.ru',
    'https://localhost',
    'https://frontend.msk1.amvera.tech',
    'https://cloud-team1.msk2.amvera.tech',
  ],
  en: ['https://cloud.waw.amverum.com'],
};

// Create the strategy with the mutable domains object
export const strategy = MyDomainStrategy<AvailableLanguageTag>({ domains });

export const middleware = Middleware({ strategy });
export const { Link, useRouter, usePathname, redirect, permanentRedirect } =
  Navigation({ strategy });

// export function updateDomainStrategy() {
//   // Get the current URL based on the current environment
//   const newRuUrl = getRuUrl();

//   // Update the domains object (this will affect the strategy)
//   domains.ru = newRuUrl;

//   console.log('Domain strategy updated with new ruUrl:', newRuUrl);
//   return newRuUrl;
// }
